<template>
  <v-dialog :value="true" max-width="500">
    <v-card class="pa-4" flat>
      <v-form @submit.prevent="createTemplate" v-model="isFormValid" ref="form">
        <v-card-title>Create template</v-card-title>
        <v-card-text
          ><div class="mb-1 subtitle-2 grey3--text">Template name</div>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            placeholder="Name"
            outlined
            dense
          ></v-text-field>
          <v-select
            v-model="category"
            :items="items"
            label="Select category"
            outlined
            dense
          ></v-select>
          <div class="mb-1 subtitle-2 grey3--text">Template message</div>
          <v-textarea
            v-model="textareaContent"
            @input="updateCharacterCount"
            :rules="messageRules"
            outlined
            name="input-7-4"
            placeholder="Type your message here."
            dense
          ></v-textarea>
          <p>
            Count: {{ characterCount }} Remaining: {{ remainingCharacters }}
          </p>

          <v-btn
            class="mt-2 primary white--text lowercase-text"
            block
            plain
            :loading="$store.state.loading.templateBtn.load"
            :disabled="$store.state.loading.templateBtn.disabled"
            type="submit"
          >
            Add template
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('close')">CLOSE</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      items: ["Promotional", "Reminder", "News", "Other"],
      name: "",
      category: "",
      textareaContent: "",
      characterLimit: 300,
      characterCount: 0,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 3) || "Name must be at least 3 characters",
      ],
      messageRules: [
        (v) => v.length <= 300 || "Message must be 160 characters or fewer",
      ],
      isFormValid: false,
    };
  },
  computed: {
    remainingCharacters() {
      return this.characterLimit - this.characterCount;
    },
  },
  methods: {
    async createTemplate() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("templates/createTemplate", {
          name: this.name,
          category: this.category,
          message: this.textareaContent,
        });
        this.closeDialog();
      }
    },
    updateCharacterCount() {
      if (this.textareaContent.length <= this.characterLimit) {
        this.characterCount = this.textareaContent.length;
      } else {
        // Truncate the content to the character limit
        this.textareaContent = this.textareaContent.substring(
          0,
          this.characterLimit
        );
      }
    },
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 10px;
}
</style>
